/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteSettingsTelegramApiToken: build.mutation<unknown, void>({
      query: () => ({
        method: 'DELETE',
        url: `/v1/settings/communication-channels/telegram-api-token`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as deleteSettingsTelegramApiTokenApi };
export const { useDeleteSettingsTelegramApiTokenMutation } = injectedRtkApi;
